/**
 * @file 年作成
 */
'use strict';

/**
 * @classname FormYearCreateView
 * @classdesc 年作成
 */
export default class FormYearCreateView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormYearCreateView.constructor');
		const date = new Date();
		const year = date.getFullYear();
		const startYear = year - 20;
		const endYear = year - 60;
		let years = '';
		for(let i = startYear; i >=  endYear; i--){
			years += `<option value="${i}">${i}</option>`;
		}
		$e.html(years);
	};
}
